"use strict";

exports.__esModule = true;
var _TabElement = require("./TabElement");
Object.keys(_TabElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabElement[key]) return;
  exports[key] = _TabElement[key];
});
var _TabFields = require("./TabFields");
Object.keys(_TabFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabFields[key]) return;
  exports[key] = _TabFields[key];
});
var _EditableTabElement = require("./EditableTabElement");
Object.keys(_EditableTabElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableTabElement[key]) return;
  exports[key] = _EditableTabElement[key];
});
var _TabWidgetThumbnail = require("./TabWidgetThumbnail");
Object.keys(_TabWidgetThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabWidgetThumbnail[key]) return;
  exports[key] = _TabWidgetThumbnail[key];
});
var _TabHeader = require("./TabHeader");
Object.keys(_TabHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabHeader[key]) return;
  exports[key] = _TabHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});